<template>
	<!-- width="390px" -->
	<!-- <el-aside class="layout-chat-left"> -->
	<div class="layout-chat-left">
		<div class="search-panel">
			<!-- <el-button @click="createChat" type="primary" size="small"><i class="el-icon-plus"></i></el-button> -->
			<el-input v-model="searchWord" @input="filter" size="large" placeholder="搜索" prefix-icon="el-icon-search" />
		</div>

		<div class="chats-panel pt10">
			<div class="chat-item-box" v-for="(item, idx) of _chatList" :key="idx">
				<div v-show="item.visible" :class="_chatingId == item.guid ? 'active' : ''" class="chat-item"
					@click="chooseChat(item)">
					<div class="chat-name-box">
						<div class="name">
							<span>{{ item.chatLunciTitle }}</span>
						</div>
						<div class="date">{{ item.showTime }}</div>
					</div>
					<!-- <div class="chat-icon-box">
					<div class="opts">
						<el-popconfirm @confirm="removeChatDialog(item.guid)" title="确定删除吗 ？">
							<a slot="reference"><i class="el-icon-delete"></i></a>
						</el-popconfirm>
					</div>
				</div> -->
				</div>
				<div class="chat-icon-box">
					<div class="opts">
						<div @click="modifyDialog" class="item">
							<i class="el-icon-edit"></i>编辑
						</div>
						<div class="item">
							<el-popconfirm @confirm="removeChatDialog(item.guid)" title="确定删除吗 ？">
								<span slot="reference"><i class="el-icon-delete"></i>删除</span>
							</el-popconfirm>
						</div>
						<div class="item" @click="generateAgent">
							<span slot="reference"><i class="el-icon-discount"></i>生成智能体</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="btn-box">
			<div @click="createChat" class="add-chat-btn">
				<img class="icon" src="@/static/icon/chat-add-icon.png" /> 新增对话
			</div>
		</div>
		<el-dialog title="创建智能体" :visible.sync="showDialog" width="800px" @close="resetForm">
			<el-form :model="agentForm" :rules="formRules" ref="agentForm" label-width="120px">
				<!-- 头像区域 -->
				<el-form-item label="智能体头像">
					<div class="avatar-upload-section">
						<div class="avatar-preview">
							<img :src="agentForm.agentAvatar" class="avatar-image" />
						</div>
					</div>
				</el-form-item>

				<!-- 基本信息 -->
				<el-form-item label="选择分类" prop="categoryGuid">
					<el-select v-model="agentForm.categoryGuid" placeholder="请选择分类" style="width: 100%">
						<el-option v-for="category in categoryList" :key="category.guid" :label="category.categoryName"
							:value="category.guid">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="智能体名称" prop="agentName">
					<el-input v-model="agentForm.agentName" placeholder="请输入智能体名称" maxlength="50" show-word-limit />
				</el-form-item>

				<el-form-item label="智能体描述" prop="agentDesc">
					<el-input v-model="agentForm.agentDesc" type="textarea" :rows="3" placeholder="请输入智能体描述" />
				</el-form-item>

				<!-- 智能体类型 -->
				<el-form-item label="智能体类型">
					<el-radio-group v-model="agentForm.agentType">
						<el-radio v-for="type in agentTypes" :key="type.value" :label="type.value">
							{{ type.label }}
						</el-radio>
					</el-radio-group>
				</el-form-item>

				<!-- 角色设定提示词 - 仅内部类型显示 -->
				<el-form-item label="角色设定提示词" prop="promptContent" v-if="agentForm.agentType === 1">
					<el-input v-model="agentForm.promptContent" type="textarea" :rows="5" placeholder="请输入角色设定提示词" />
				</el-form-item>

				<!-- 密钥读取类型 - 非内部类型显示 -->
				<el-form-item label="密钥读取类型" v-if="agentForm.agentType !== 1">
					<el-radio-group v-model="agentForm.agentConfig.secret_key_type">
						<el-radio v-for="type in secretTypes" :key="type.value" :label="type.value">
							{{ type.label }}
						</el-radio>
					</el-radio-group>
				</el-form-item>

				<!-- 扣子智能体ID - 仅Coze类型显示 -->
				<el-form-item label="扣子智能体ID" v-if="agentForm.agentType === 3">
					<el-input v-model="agentForm.agentConfig.coze_sign" placeholder="请输入扣子智能体ID" />
				</el-form-item>

				<!-- 智能体秘钥 - 非内部类型显示 -->
				<el-form-item label="智能体秘钥" v-if="agentForm.agentType !== 1">
					<el-input v-model="agentForm.agentConfig.secret_token" placeholder="请输入智能体秘钥" type="password" show-password />
				</el-form-item>

				<!-- Dify自定义部署地址 - 仅Dify类型显示 -->
				<el-form-item label="Dify部署地址" v-if="agentForm.agentType === 2">
					<el-input v-model="agentForm.agentConfig.deploy_address" placeholder="请输入Dify自定义部署地址" />
				</el-form-item>

				<!-- 开场白 -->
				<el-form-item label="开场白">
					<el-input v-model="agentForm.welcomeMessage" placeholder="请输入开场白" />
				</el-form-item>

				<!-- 引导问题列表 -->
				<el-form-item label="引导问题">
					<div class="question-list">
						<el-input v-for="(question, index) in agentForm.commonQuestions" :key="index"
							v-model="agentForm.commonQuestions[index]" :placeholder="`请输入引导问题${index + 1}`"
							style="margin-bottom: 8px;" />
					</div>
				</el-form-item>

				<!-- 智能体类型（免费/付费） -->
				<el-form-item label="智能体类型">
					<el-radio-group v-model="agentForm.isPaid">
						<el-radio v-for="type in visibilityTypes" :key="type.value" :label="type.value">
							{{ type.label }}
						</el-radio>
					</el-radio-group>
				</el-form-item>

				<!-- 收费金额 - 仅付费类型显示 -->
				<el-form-item label="收费金额" prop="price" v-if="agentForm.isPaid === 1">
					<el-input v-model="agentForm.price" placeholder="请输入收费金额" type="number" step="0.01">
						<template slot="append">元</template>
					</el-input>
				</el-form-item>

				<!-- 试用聊天次数 - 仅付费类型显示 -->
				<el-form-item label="试用聊天次数" v-if="agentForm.isPaid === 1">
					<el-input v-model="agentForm.trial_chat_count" placeholder="请输入试用聊天次数" type="number">
						<template slot="append">次</template>
					</el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="showDialog = false">取消</el-button>
				<el-button type="primary" @click="saveAgent" :loading="saving">创建</el-button>
			</div>
		</el-dialog>
	</div>
	<!-- </el-aside> -->
	<!-- 创建/编辑智能体对话框 -->

</template>

<script>
import { removeChatDialog, updateChat, parseFromChatApi } from '@/apis/chat';
import { createAgentApi, getCategoryListApi } from '@/apis/agent';
export default {
	name: 'layout-chat-left',

	async mounted() {
		await this.loadCategoryList()
	},

	props: {
		_chatingId: String,
		_chatList: Array,
		_onChatState: Boolean,
	},

	data() {
		return {
			searchWord: '',
			showDialog: false,
			generating: false,
			agentForm: {
				merchantGuid: '',
				agentName: '',
				agentType: 1, // 默认内部类型
				categoryGuid: '',
				promptContent: '',
				agentDesc: '',
				agentAvatar: '',
				isPaid: 0, // 默认免费
				price: '',
				trial_chat_count: 0, // 试用聊天次数
				isPublic: 1, // 默认公开
				agentConfig: {
					deploy_address: '',
					coze_sign: '',
					secret_token: '',
					secret_key_type: 'default'
				},
				knowledgeBaseIds: [],
				welcomeMessage: '',
				commonQuestions: ['', '', ''] // 默认3个问题
			},
			saving: false,
			agentTypes: [
				{ value: 1, label: '内部智能体' },
				{ value: 2, label: 'Dify智能体' },
				{ value: 3, label: 'Coze智能体' },
			],
			// 可见性类型选项
			visibilityTypes: [
				{ value: 0, label: '免费' },
				{ value: 1, label: '付费' }
			],
			formRules: {
				agentName: [
					{ required: true, message: '请输入智能体名称', trigger: 'blur' },
					{ min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
				],
				agentDesc: [
					{ required: true, message: '请输入描述', trigger: 'blur' },
					{ min: 10, max: 500, message: '长度在 10 到 500 个字符', trigger: 'blur' }
				],
				promptContent: [
					{ required: false, message: '请输入系统提示词', trigger: 'blur' },
				],
				categoryGuid: [
					{ required: true, message: '请选择分类', trigger: 'change' }
				],
				price: [
					{ required: false, message: '请输入价格', trigger: 'blur' },
					{ pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的价格格式', trigger: 'blur' }
				]
			},
			categoryList: [],
		};
	},

	methods: {
		filter() {
			if (this.searchWord === '') {
				this._chatList.forEach(item => {
					item.visible = true;
				});
			} else {
				this._chatList.forEach(item => {
					item.visible = item.chatLunciTitle.includes(this.searchWord);
				});
			}
		},
		resetForm() {
			this.agentForm = {
				merchantGuid: this.merchantGuid,
				agentName: '',
				agentType: 1,
				categoryGuid: '',
				promptContent: '',
				agentDesc: '',
				agentAvatar: '',
				isPaid: 0,
				price: '',
				trial_chat_count: 0,
				isPublic: 1,
				agentConfig: {
					deploy_address: '',
					coze_sign: '',
					secret_token: '',
					secret_key_type: 'default'
				},
				knowledgeBaseIds: [],
				welcomeMessage: '',
				commonQuestions: ['', '', '']
			}
			this.editingAgent = null
			this.selectedCategory = null
			if (this.$refs.agentForm) {
				this.$refs.agentForm.clearValidate()
			}
		},
		// 加载分类列表
		async loadCategoryList() {
			try {
				const res = await getCategoryListApi({
					merchantGuid: this.$store.state.merchantGuid,
				})
				if (res && res.code === 0) {
					this.categoryList = res.data || []
				}
			} catch (error) {
				console.error('获取分类列表失败:', error)
			}
		},
		async saveAgent() {
			try {
				await this.$refs.agentForm.validate()

				// 表单验证
				if (!this.agentForm.categoryGuid) {
					this.$message.warning('请选择分类')
					return
				}

				if (!this.agentForm.agentName.trim()) {
					this.$message.warning('请输入智能体名称')
					return
				}

				if (this.agentForm.isPaid === 1 && !this.agentForm.price) {
					this.$message.warning('付费智能体请输入价格')
					return
				}

				this.saving = true

				// 过滤空的引导问题
				const filteredQuestions = this.agentForm.commonQuestions.filter(q => q && q.trim())

				const submitData = {
					agentName: this.agentForm.agentName.trim(),
					agentType: this.agentForm.agentType,
					categoryGuid: this.agentForm.categoryGuid,
					promptContent: this.agentForm.promptContent ? this.agentForm.promptContent.trim() : '',
					agentDesc: this.agentForm.agentDesc ? this.agentForm.agentDesc.trim() : '',
					agentAvatar: this.agentForm.agentAvatar,
					isPaid: this.agentForm.isPaid,
					price: this.agentForm.isPaid === 1 ? parseFloat(this.agentForm.price) : 0,
					isPublic: 1, // 暂时都设为公开
					trial_chat_count: this.agentForm.trial_chat_count || 0,
					agentConfig: this.agentForm.agentConfig,
					knowledgeBaseIds: this.agentForm.knowledgeBaseIds,
					welcomeMessage: this.agentForm.welcomeMessage ? this.agentForm.welcomeMessage.trim() : '',
					commonQuestions: filteredQuestions
				}

				// 创建模式
				submitData.merchantGuid = this.$store.state.merchantGuid
				const res = await createAgentApi(submitData)

				if (res && res.code === 0) {
					this.$message.success('创建成功')
					this.showDialog = false
					// 跳转到智能体页面，并切换到我的智能体tab
					this.$router.push('/app/agent?tab=my-agents')
				} else {
					this.$message.error(res?.msg || '创建失败')
				}

			} catch (error) {
				this.$message.error(res?.msg || '创建失败')
			} finally {
				this.saving = false
			}
		},
		async generateAgent() {
			if (!this._chatingId) {
				this.$message.warning('请先选择一个对话')
				return
			}

			// 显示loading提示
			const loading = this.$loading({
				lock: true,
				text: '正在检索数据生成中，请稍候...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			})

			this.generating = true

			try {
				// 调用接口，超时时间10分钟(600000ms)
				const res = await parseFromChatApi({
					merchantGuid: this.$store.state.merchantGuid,
					chatLunciGuid: this._chatingId
				}, 600000)

				if (res && res.code === 0 && res.data) {
					const data = res.data



					// 映射数据到表单
					this.agentForm = {
						merchantGuid: data.merchantGuid || this.$store.state.merchantGuid,
						agentName: data.agentName || '',
						agentType: data.agentType || 1,
						categoryGuid: data.categoryGuid || '',
						promptContent: data.promptContent || '',
						agentDesc: data.agentDesc || '',
						agentAvatar: data.agentAvatar || 'https://ai-v2.deepcity.cn/default/head.png',
						isPaid: data.isPaid || 0,
						price: data.price || 0,
						trial_chat_count: data.trial_chat_count || 0,
						isPublic: data.isPublic || 1,
						agentConfig: data.agentConfig || {
							deploy_address: '',
							coze_sign: '',
							secret_token: '',
							secret_key_type: 'default'
						},
						knowledgeBaseIds: data.knowledgeBaseIds || [],
						welcomeMessage: data.welcomeMessage || '',
						commonQuestions: data.commonQuestions && data.commonQuestions.length > 0
							? data.commonQuestions
							: ['', '', '']
					}

					// 显示创建智能体弹窗
					this.showDialog = true
					this.$message.success('数据生成完成')
				} else {
					this.$message.error(res?.msg || '生成智能体失败')
				}
			} catch (error) {
				console.error('生成智能体失败:', error)
				this.$message.error('生成智能体失败，请重试')
			} finally {
				loading.close()
				this.generating = false
			}
		},

		async removeChatDialog(guid) {
			await removeChatDialog(guid);
			this.$emit('reloadList');
			this.$message({ message: '已删除', type: 'success' });
		},

		modifyDialog() {
			let self = this;

			let chatObj = this._chatList.find(item => item.guid == this._chatingId);
			let idx = this._chatList.findIndex(item => item.guid == self._chatingId);

			this.$prompt('', '修改对话', {
				inputValue: chatObj.chatLunciTitle,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			}).then(async ({ value }) => {
				await updateChat(chatObj.guid, value);
				this.$set(this._chatList[idx], 'chatLunciTitle', value);

				self.$message({
					showClose: true,
					message: '更新成功',
					type: 'success',
				});
			});
		},

		createChat() {
			if (this._onChatState) {
				this.$emit('createChat');
			} else {
				this.$message({
					showClose: true,
					message: '有生成任务进行中，暂不可新增对话',
					type: 'warning',
				});
				return;
			}
		},

		chooseChat({ guid }) {
			if (this._onChatState) {
				this.$emit('update:_chatingId', guid);
			} else {
				this.$message({
					showClose: true,
					message: '有生成任务进行中，暂不可切换',
					type: 'warning',
				});
				return;
			}
		},
	},

	computed: {},
};
</script>

<style lang="scss" scoped>
.layout-chat-left {
	width: 250px;
	flex-shrink: 0;
	border-right: solid 1px var(--border-color);
	padding: 10px;
	background: rgb(250 251 255);
	background-color: #fff;
	overflow-y: auto;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	position: relative;

	.chats-panel {
		flex: 1;
		padding-bottom: 68px;
		overflow-x: hidden;
		overflow-y: auto;

		.chat-item-box {
			.chat-icon-box {
				margin-bottom: 10px;

				.opts {
					width: 100%;
					display: flex;

					// justify-content: space-around;
					.item {
						display: flex;
						align-items: center;
						justify-content: center;
						margin: 0 10px;
						cursor: pointer;
						font-size: 12px;
						color: #999999;
					}
				}
			}
		}


	}

	.add-chat-btn {
		width: 225px;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		background: linear-gradient(90deg, #f5eefe 0%, #edeefd 53%, #e8effe 100%);
		color: #4958ec;
		font-size: 14px;
		border-radius: 8px;
		position: absolute;
		left: 10px;
		bottom: 10px;
		cursor: pointer;

		.icon {
			display: block;
			width: 20px;
			height: 20px;
			margin-right: 10px;
		}
	}

	.chat-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px;
		// border: solid 1px var(--border-color);
		// background: white;
		background-color: #fafbfc;
		border-radius: 6px;
		margin-bottom: 8px;

		.chat-name-box {
			flex: 1;
			cursor: pointer;
		}

		.opts {
			color: var(--text-black-light);
		}

		.name {
			font-size: 15px;
			font-weight: bold;
			margin-bottom: 4px;
			color: var(--text-black);
		}

		.date {
			font-size: 12px;
			color: var(--text-black-light);
		}

		&.active,
		&:hover {
			//border: solid 1px var(--primary);
			// background: var(--primary-light);

			.name {
				// color: var(--primary);
				color: #4958ec;
			}

			.opts {
				color: #4958ec;
			}
		}
	}
}

@media screen and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
	.layout-chat-left {
		width: 200px;

		.chat-item {
			padding: 4px;
			margin-bottom: 40px;
			position: relative;

			// flex-direction: column;
			// align-items: start;
			.name {
				font-size: 12px;
			}

		}



	}
}
</style>
